<template>
  <div id="app">
    <!-- <img src="./assets/logo.png" class="hvr-bounce-in" /> -->
    <!-- <transition :name="transitionName"> -->
    <router-view />
    <!-- :key="$route.fullPath"  -->
    <!-- </transition> -->
  </div>
</template>

<script>
import "babel-polyfill";
export default {
  name: "App",
  data() {
    return {
      transitionName: "fade",
    };
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      if (type != "online") {
        this.$router.push("/network_error");
      }
    },
  },
  mounted() {
    // window.addEventListener("online", this.updateOnlineStatus); // 网络由异常到正常时触发
    // window.addEventListener("offline", this.updateOnlineStatus); // 网络由正常常到异常时触发
  },
  watch: {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  margin: 0;
  padding: 0;
}
/*修改滚动条样式*/
div::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  /**/
}
div::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
div::-webkit-scrollbar-thumb {
  background: #9dbef6;
  border-radius: 6px;
}
div::-webkit-scrollbar-thumb:hover {
  background: #9dbef6;
}
div::-webkit-scrollbar-corner {
  background: #9dbef6;
}
.el-icon-close:before {
  color: #ffffff !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #3b7eee;
  border-color: #3b7eee;
}
/* span {
  font-size: 14px !important;
} */
.el-select-dropdown__item span {
  font-size: 14px;
}
.el-message {
  z-index: 9999 !important;
}
.el-loading-mask {
  z-index: 8888 !important;
}
</style>




// WEBPACK FOOTER //
// src/App.vue